import { gql } from '@apollo/client'
import { ABSTRACT_SEARCH_ITEM } from '../fragments/interface.fragment'
import { allContentFragments } from '../fragments/allContent.fragment'

export const GET_ALGOLIA_CONTENT = gql`
  query GetAlgoliaContent($input: AlgoliaContentInput!) {
    algoliaContent(input: $input) {
      meta {
        page
        pageSize
        count
        totalPages
      }

      data {
        ...AllContentItemNode
      }
    }
  }
  ${allContentFragments.fragments.node}
  ${ABSTRACT_SEARCH_ITEM}
`
